import KnowledgeBaseListPage from 'src/pages/chatbot/admin/KnowledgeBaseListPage';
import KnowledgeBaseCreatePage from 'src/pages/chatbot/admin/KnowledgeBaseCreatePage';
import KnowledgeBaseEditPage from 'src/pages/chatbot/admin/KnowledgeBaseEditPage';

export const chatbotRoutes = [
  { path: '/admin/knowledge-base/questions', component: KnowledgeBaseListPage, exact: true },
  { path: '/admin/knowledge-base/questions/new', component: KnowledgeBaseCreatePage },
  { path: '/admin/knowledge-base/questions/:id/edit', component: KnowledgeBaseEditPage },
];
